import { getAuthorization } from 'controllers/controller';
import { setFlag } from 'controllers/flags';
import { getDocumentSignedUrlService } from 'services/expenseParser/getDocumentSignedUrl';
import { parseIdCardService } from 'services/idParser/parseIdCard';

export const idCardParser = async (files, type) => {
  const authorization = getAuthorization();
  const TYPE_MAP = {
    'indonesian-id': 'indo-id-extraction',
    'indian-pan-card': 'pan-extraction',
    'indian-aadhaar-card': 'aadhaar-extraction',
  };

  if (files.length > 1) {
    setFlag('ResumeParserMultipleFilesError', true);
    return null;
  }

  const { data, status } = await parseIdCardService(
    authorization,
    files,
    TYPE_MAP[type]
  );

  if (status !== 200) {
    setFlag('ResumeParserFileTypeError', true);
    return null;
  }

  const parsedData = data && data.content ? data.content : null;

  // const resumeLink = {};
  const resumeLink = data
    ? await getDocumentSignedUrlService(authorization, data.filename)
    : null;

  return {
    json: parsedData,
    resumeLink: resumeLink.data ? resumeLink.data.response : '',
    filename: data ? data.filename : '',
  };
};
